import Feed from "../containers/Feed";
import User from "../containers/User";
import Post from "../containers/Post";
import Media from "../containers/Media";
import Album from "../containers/Album";
import Promotion from "../containers/Promotion";
import Chat from "../containers/Chat";
import Search from "../containers/Search";
import Polling from "../containers/Polling";


import components from "../components";

/* List of all container classes */
const allContainers = {
    Feed      : Feed,
    User      : User,
    Post      : Post,
    Media     : Media,
    Album     : Album,
    Promotion : Promotion,
    Chat      : Chat,
    Search    : Search,
    Polling   : Polling,
   
};

/* List of all component classes */
const allComponents = {
    Auth         : components.Auth,
    StaticPage   : components.StaticPage,
    Termsncondition : components.Termsncondition,
    PrivacyPolicy   : components.PrivacyPolicy,
    PaymentPolicy : components.PaymentPolicy,
    RefundPolicy : components.RefundPolicy,
    SubscriptionCanellationPolicy : components.SubscriptionCanellationPolicy,
    DeliveryPolicy : components.DeliveryPolicy,
    ContactUs : components.ContactUs,
    FAQ         : components.FAQ,
    About : components.About,
    NotFoundPage : components.NotFoundPage
}


const routePages = Object.assign(
    allContainers, 
    allComponents
);

export default routePages;